import luxonGenerateConfig from '@rc-component/picker/generate/luxon';
import DatePicker from 'antd/es/date-picker';
import type { DateTime } from 'luxon';

// The generated MonthPicker keeps its generics, so callers get DateTime-typed
// onChange. Wrapping it in an FC collapses them to unknown.
const { MonthPicker } = DatePicker.generatePicker<DateTime>(luxonGenerateConfig);

export default MonthPicker;
